module.exports = __webpack_public_path__ + "static/media/011-boy-5.6ed02346.svg";